import { Cloud, CloudOff, HardDrive, Loader2 } from 'lucide-react'
import { useAuthStore } from '../../store/authStore'
import { useSyncStore } from '../../store/syncStore'

export default function SyncIndicator() {
  const user = useAuthStore((s) => s.user)
  const { status, pending, error } = useSyncStore()
  if (!user) return <span className="status-pill" title="Dados salvos somente neste navegador"><HardDrive size={13} /> Neste dispositivo</span>
  if (status === 'offline' || status === 'error') return <span className="status-pill bg-amber-900/50 text-amber-200" title={error ?? 'Sem conexão'}><CloudOff size={13} /> {pending ? `${pending} pendente` : 'Offline'}</span>
  if (status === 'loading' || status === 'pending') return <span className="status-pill"><Loader2 size={13} className="animate-spin" /> Sincronizando</span>
  return <span className="status-pill"><Cloud size={13} /> Sincronizado</span>
}
